import React from 'react';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../../components/ui/select';
import { Card, CardContent } from '../../components/ui/card';
import PatientSuggest from '../../components/PatientSuggest';
import { PAYER_TYPES } from '../../constants/patientConstants';

export const PatientsFilters = ({
  search, onSuggestSelect,
  filterPayer, onFilterPayer,
  filterStatus, onFilterStatus,
}) => (
  <Card>
    <CardContent className="py-4">
      <div className="flex flex-col sm:flex-row gap-4">
        <div className="flex-1">
          <PatientSuggest
            onSelect={onSuggestSelect}
            placeholder="Search by name or Medicaid ID..."
            value={search}
            className="w-full"
          />
        </div>
        <Select value={filterPayer} onValueChange={onFilterPayer}>
          <SelectTrigger className="w-full sm:w-48" data-testid="filter-payer">
            <SelectValue placeholder="All Payers" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Payers</SelectItem>
            {PAYER_TYPES.map((p) => (
              <SelectItem key={p.value} value={p.value}>{p.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Select value={filterStatus} onValueChange={onFilterStatus}>
          <SelectTrigger className="w-full sm:w-40" data-testid="filter-status">
            <SelectValue placeholder="All Status" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Status</SelectItem>
            <SelectItem value="Active">Active</SelectItem>
            <SelectItem value="Needs completion">⚠ Needs completion</SelectItem>
            <SelectItem value="Inactive">Inactive</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </CardContent>
  </Card>
);

export default PatientsFilters;
